module.exports = __webpack_public_path__ + "media/svg-new/dashboard3-b5b36213.svg";